const DESKTOP_SELECTOR = '[js-header-cart-count-desktop]';
const MOBILE_SELECTOR = '[js-header-cart-count-mobile]';

export const setHeaderCartCount = (count = 0) => {
  const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;

  document.querySelectorAll(DESKTOP_SELECTOR).forEach((el) => {
    if (safeCount <= 0) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    el.hidden = false;
    el.textContent = ` (${safeCount})`;
  });

  document.querySelectorAll(MOBILE_SELECTOR).forEach((el) => {
    if (safeCount <= 0) {
      el.textContent = '';
      el.hidden = true;
      return;
    }

    el.textContent = String(safeCount);
    el.hidden = false;
  });
};

export const fetchHeaderCartCount = async () => {
  const response = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error('Unable to fetch cart count');
  }

  const cart = await response.json();
  return Number(cart?.item_count || 0);
};

export const refreshHeaderCartCount = async () => {
  const count = await fetchHeaderCartCount();
  setHeaderCartCount(count);
  return count;
};
